import styled from 'styled-components';

export const BlackCanvas = styled.div`
  background-color: #000000;
  // width: 99%;
  // height: 70%;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  gap: 1em;
  position: relative;
  max-height: calc(100% - 125px - 2em);
  overflow: hidden;
  background: black;
  margin: 10px;
`;
